module.exports = __webpack_public_path__ + "img/Kiribati.28123c9b.png";